'use client'

import dynamic from 'next/dynamic'

import '@/components/Button/Button.scss'
import '@/components/Form/Atoms/SubmitButton/SubmitButton.scss'
import { Props } from '@/components/Form/Atoms/SubmitButton/SubmitButtonLogic'

const SubmitButtonLogic = dynamic(() => import('@/components/Form/Atoms/SubmitButton/SubmitButtonLogic'), {
  ssr: true,
})

const SubmitButton = ({
  children,
  submittingText = 'しばらくお待ちください',
  width,
  lineHeight,
  padding,
  textColor,
  bgColor,
  skelton = false,
  allowDirty = false,
  fixUi = false,
  disabled = false,
}: Props) => {
  return (
    <SubmitButtonLogic
      submittingText={submittingText}
      width={width}
      lineHeight={lineHeight}
      padding={padding}
      textColor={textColor}
      bgColor={bgColor}
      skelton={skelton}
      allowDirty={allowDirty}
      fixUi={fixUi}
      disabled={disabled}
    >
      {children}
    </SubmitButtonLogic>
  )
}

export default SubmitButton
